export function getColorFromMuiVar(color) {
    if (color.includes('var'))
        return color.split(',').at(-1)?.trim().slice(0, 6) ?? '';
    return color;
}
//# sourceMappingURL=getColorFromMuiVar.js.map